declare const window: any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const COUNTDOWN = 5;

export const IS_LOCAL = typeof window !== 'undefined' && window.location.protocol === 'http:';

export const ANALYTICS_HOST = 'https://ha.harryonline.net';

export const SENTRY_HOST = 'https://o193370.ingest.us.sentry.io';
export const SENTRY_URL = 'https://434d52b288ea630bb3987f1b8e848b79@o193370.ingest.us.sentry.io/4509504864256000';
export const WEBSITE_ID = 'a6e3c646-f93e-4a31-b0e1-619c91c53eab';
